import Job from './pages/Jinrai/Job';
import Home from './pages/Jinrai/Home';
import About from './pages/Jinrai/About';
import Contact from './pages/Jinrai/Contact';
import Portfolio from './pages/Jinrai/Portfolio';
import PrivacyPolicy from "./pages/Jinrai/PrivacyPolicy";
import TermsConditions from "./pages/Jinrai/TermsConditions";
import CancellationPolicy from "./pages/Jinrai/CancellationPolicy";

import NotFound from './component/notFound/NotFound';
import JobApplyForm from './pages/Jinrai/JobApplyForm';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RoleProtectedRoute from './pages/Inventory/RoleProtectedRoute';
import ProtectedRoute from "./pages/admin/ProtectedRoute"
import Dashboard from "./pages/admin/Dashboard"
import Login from "./pages/admin/Login"
import EventForm from './pages/eventForm/eventForm';
import Clients from './pages/Jinrai/Clients';
import ContactQR from './pages/qr/ContactQR';
import ProfileCard from './pages/qr/ProfileCard';
import CreateAccountForm from './pages/qr/CreateAccountForm';
import QrLoginScreen from './pages/qr/QrLoginScreen';
import QrDashboard from './pages/qr/QrDashboard';

// Inventory System
import Invoice from './pages/Inventory/Invoice';
import CrmInvoice from './pages/Crm/CrmInvoice';
import { DashboardInventory } from './pages/Inventory/DashboardInventory';
import InventoryLogin from './features/Inventory/auth/InventoryLogin';
import { ViewInvoice } from './pages/Inventory/ViewInvoice';
import UserManagement from './pages/Inventory/Customer';
import { ManageInvoice } from './pages/Inventory/ManageInvoice';
import ManageCustomer from './pages/Inventory/ManageCustomer/ManageCustomer';
import ManageProduct from './pages/Inventory/ManageProduct';
import PurchaseOrder from './pages/Inventory/PurchaseOrder/PurchaseOrder';
import { ManagePurchaseOrder } from './pages/Inventory/PurchaseOrder/ManagePurchaseOrder';
import ViewProduct from './pages/Inventory/PurchaseOrder/ViewProduct';
import ManageItem from './pages/Inventory/PurchaseOrder/ManageItem';
import EditInvoice from './pages/Inventory/EditInvoice/EditInvoice';
import EditPurchaseOrder from './pages/Inventory/PurchaseOrder/EditPurchaseOrder/EditPurchaseOrder';

// Mini CRM
import CrmRegistration from './features/Crm/Crmauth/CrmRegistration';
import CrmLogin from './features/Crm/Crmauth/CrmLogin';
import { DashboardCrm } from './pages/Crm/DashboardCrm';
import { CrmViewInvoice } from './pages/Crm/CrmViewInvoice';
import CrmUserManagement from './pages/Crm/CrmCustomer';
import { CrmManageInvoice } from './pages/Crm/CrmManageInvoice';
import CrmManageCustomer from './pages/Crm/CrmManageCustomer/CrmManageCustomer';
import CrmManageProduct from './pages/Crm/CrmManageProduct';
import CrmPurchaseOrder from './pages/Crm/CrmPurchaseOrder/CrmPurchaseOrder';
import { CrmManagePurchaseOrder } from './pages/Crm/CrmPurchaseOrder/CrmManagePurchaseOrder';
import CrmViewProduct from './pages/Crm/CrmPurchaseOrder/CrmViewProduct';
import CrmViewDirectSales from './pages/Crm/CrmPurchaseOrder/CrmViewDirectSales';
import CrmViewIndirectSales from './pages/Crm/CrmPurchaseOrder/CrmViewIndirectSales';
import CrmManageItem from './pages/Crm/CrmPurchaseOrder/CrmManageItem';
import CrmEditInvoice from './pages/Crm/CrmEditInvoice/CrmEditInvoice';
import CrmEditPurchaseOrder from './pages/Crm/CrmPurchaseOrder/CrmEditPurchaseOrder/CrmEditPurchaseOrder';
import CrmManageDiractSales from './pages/Crm/CrmManageDiractSales/CrmManageDiractSales';
import { CrmManageIndiractSales } from './pages/Crm/CrmManageIndiractSales/CrmManageIndiractSales';
import CrmProfile from './pages/Crm/CrmProfile';
import CrmAddProduct from './pages/Crm/CrmAddProduct';
import CrmRoleProtectedRoute from './pages/Crm/CrmRoleProtectedRoute';
import ResetPasswordEmail from './component/CrmUI/reset-password/ResetPasswordEmail';
import CrmEditProductDetails from './features/Crm/CrmManageProduct/CrmEditProduct';
import ViewDirectSales from './pages/Inventory/PurchaseOrder/ViewDirectSales';
import ManageDiractSales from './pages/Inventory/ManageDiractSales/ManageDiractSales';
import ViewIndirectSales from './pages/Inventory/PurchaseOrder/ViewIndirectSales';
import { ManageIndiractSales } from './pages/Inventory/ManageIndiractSales/ManageIndiractSales';
import ResetPasswordEmailQr from './pages/qr/reset-password/ResetPasswordEmailQr';
import RegistrationQr from './pages/qr/RegistrationQr';
import RegistrationCrm from './pages/Crm/RegistrationCrm';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/clients' element={<Clients />} />
        <Route path='/job' element={<Job />} />
        <Route path='/job-apply' element={<JobApplyForm />} />

        <Route path='/terms-conditions' element={<TermsConditions />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/cancellation-policy' element={<CancellationPolicy />} />



        <Route path='/contact-card' element={<RegistrationQr />} />
        <Route path='/contact-card/contact/:userId' element={<ProfileCard />} />
        <Route path='/contact-card/:userId' element={<ContactQR />} />
        <Route path='/contact-card/create-account' element={<CreateAccountForm />} />
        <Route path='/contact-card/reset-password' element={<ResetPasswordEmailQr />} />
        <Route path='/contact-card/login' element={<QrLoginScreen />} />
        <Route path='/contact-card/dashboard/:userId' element={<QrDashboard />} />

        {/* Inventory system */}
        <Route path='/inventory/login' element={<InventoryLogin />} />
        <Route path='/inventory/create-invoice' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <Invoice />
          </RoleProtectedRoute>
        } />
        {/* <Route path='/inventory/dashboard' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <DashboardInventory />
          </RoleProtectedRoute>
        } /> */}
        <Route path='/inventory/view-invoice' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ViewInvoice />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/users' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <UserManagement />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-invoice' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ManageInvoice />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-customer' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ManageCustomer />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-product' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ManageProduct />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/purchase-order' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <PurchaseOrder />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-purchase-order' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ManagePurchaseOrder />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/view-product' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ViewProduct />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/view-direct-sales' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ViewDirectSales />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/view-indirect-sales' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ViewIndirectSales />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-purchase-item' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <ManageItem />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/edit-invoice' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <EditInvoice />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/edit-purchase-order' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <EditPurchaseOrder />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-diract-sales' element={
          <RoleProtectedRoute allowedRoles={['admin', 'salesPerson', 'subAdmin']}>
            <ManageDiractSales />
          </RoleProtectedRoute>
        } />
        <Route path='/inventory/manage-indiract-sales' element={
          <RoleProtectedRoute allowedRoles={['admin', 'salesPerson', 'subAdmin']}>
            < ManageIndiractSales />
          </RoleProtectedRoute>
        } />

        {/* CRM */}
        <Route path='/crm' element={<RegistrationCrm />} />
        <Route path='/crm/registration' element={<CrmRegistration />} />
        <Route path='/crm/login' element={<CrmLogin />} />
        <Route
          path="/crm/reset-password"
          element={
            <ResetPasswordEmail />
          }
        />
        <Route path='/crm/create-invoice' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmInvoice />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/edit-invoice' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmEditInvoice />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/profile' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmProfile />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/add-product' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmAddProduct />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/edit-product' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmEditProductDetails />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/dashboard' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <DashboardCrm />
          </CrmRoleProtectedRoute>
        } />

        <Route path='/crm/view-invoice' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmViewInvoice />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/users' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmUserManagement />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/manage-invoice' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmManageInvoice />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/manage-customer' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmManageCustomer />
          </CrmRoleProtectedRoute>
        } />
        <Route path='/crm/manage-product' element={
          <CrmRoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmManageProduct />
          </CrmRoleProtectedRoute>
        } />


        {/* <Route path='/crm/purchase-order' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmPurchaseOrder />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/manage-purchase-order' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmManagePurchaseOrder />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/view-product' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmViewProduct />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/view-direct-sales' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
            >
            <CrmViewDirectSales />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/view-indirect-sales' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmViewIndirectSales />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/manage-purchase-item' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
            >
            <CrmManageItem />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/edit-invoice' element={
          <RoleProtectedRoute
          allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmEditInvoice />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/edit-purchase-order' element={
          <RoleProtectedRoute
            allowedRoles={['admin', "salesPerson", "subAdmin"]}
          >
            <CrmEditPurchaseOrder />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/manage-diract-sales' element={
          <RoleProtectedRoute allowedRoles={['admin', 'salesPerson', 'subAdmin']}>
            <CrmManageDiractSales />
          </RoleProtectedRoute>
        } />
        <Route path='/crm/manage-indiract-sales' element={
          <RoleProtectedRoute allowedRoles={['admin', 'salesPerson', 'subAdmin']}>
            <CrmManageIndiractSales />
          </RoleProtectedRoute>
        } />  */}

        {/* Admin Routes */}
        <Route path='/admin/login' element={<Login />} />
        <Route path='/event/form' element={<EventForm />} />
        <Route path='/admin' element={<ProtectedRoute />}>
          <Route path='create-job' element={<Dashboard />} />
        </Route>

        {/* Fallback Route */}
        <Route path='*' element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;